// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2TOhy","header":"ReportDetails_header__2-6XL","title":"ReportDetails_title__7Czv5","left":"ReportDetails_left__1bSci"};